export function featureTeacherSelectorFnMaker() {
    return session => {
        return session.Teacher.all().filter({
            isFeature: true
        }).toModelArray().map(teacher => {
            const obj = teacher.ref;
            return Object.assign({}, obj);
        });
    }
}

export function programSelectorFnMaker(id) {
    return session => {
        const program = session.Program.withId(String(id));
        if (program === null) {
            return null;
        }
        return Object.assign({}, program.ref, {
            courses: program.courses.toRefArray().map(course => Object.assign({}, course)),
        });
    }
}

export function selectTermsFromProgram(program) {
    let courses = program && program.courses;
    if (!courses) {
        courses = [];
    }
    const result = {};
    courses.forEach((course, index) => {
        if (result[course.term]) {
            result[course.term].push(course);
        } else {
            result[course.term] = [course];
        }
    });
    const termResult = Object.entries(result).sort((a, b) => a[0] - b[0]).map(item => {
        if (item[0] === "null") {
            return null
        }
        return {
            title: `ترم ${item[0]}`,
            courses: item[1]
        }
    }).filter(item => item !== null);
    return termResult
}